import PropTypes from 'prop-types';
import React, {Component} from 'react';
import App from '../containers/App'
import AppHeader from './AppHeader'
import AppFooter from '../components/AppFooter'
import ContentPopup from '../containers/contentpopup/ContentPopup'
import {connect} from "react-redux";
import {getCartAllowedForCustomerChange, getCartId} from "../selectors/SimpleSelectors";
import {isMode} from "../selectors/Mode";
import {APP_MODE_ACCESSORY, APP_MODE_AGENCYSERVER_ADD_PROJECT, APP_MODE_AUTHENTICATED_ORDER, APP_MODE_OUTSOURCING, APP_MODE_PRODUCT_CHANGE} from "../constants/General";
import {getSelectedArticle} from "../selectors/ProductSelection";
import ReactTooltip from 'react-tooltip';
import CookieConsent from "../components/CookieConsent";
import PinCodeInput from "./outsourcing/PinCodeInput";
import {getMainArticleInCart} from "../selectors/Cart";

class AppWrapper extends Component {

    static propTypes = {
        baseAddon: PropTypes.string,
        baseArticleId: PropTypes.string,
        initialCartId: PropTypes.string,
        initParams: PropTypes.object,
        columnWidth: PropTypes.string,
        appInitialized: PropTypes.bool
    }

    componentDidMount() {
        setTimeout(() => {
            ReactTooltip.rebuild();
        }, 1000);
    }

    constructor(props) {
        super(props);

        this.tooltipRef = React.createRef();
    }

    render() {

        const {initParams, appInitialized, baseAddon, initialCartId} = this.props
        const baseArticleId = this.props.baseArticleId

        let actualCartId = initialCartId;

        let content;

        if (this.props.isAllowedForCustomerChange && !this.props.pinCodeVerified) {

            // If a user accepts an outsourcing request, the cart is protected by a pin code. The user has to enter the pin code first.
            content = <PinCodeInput/>

        } else if (baseArticleId) {

            // regular app with potential baseaddon
            content = <App initialCartId={actualCartId} initParams={initParams} baseArticleId={baseArticleId} baseAddon={baseAddon}/>

        } else if (
            isMode(APP_MODE_OUTSOURCING) ||
            isMode(APP_MODE_AUTHENTICATED_ORDER) ||
            isMode(APP_MODE_PRODUCT_CHANGE) ||
            isMode(APP_MODE_ACCESSORY) ||
            isMode(APP_MODE_AGENCYSERVER_ADD_PROJECT)
        ) {

            // in these order flows the base article is being determined by url / cart parameters
            content = <App initialCartId={actualCartId} initParams={initParams} baseArticleId={this.props.selectedOutsourcingBaseArticle}/>

        }

        return (
            <div className="page-wrapper">
                <ContentPopup/>
                <ReactTooltip
                    className="global-tooltip"
                    effect="float"
                    type="light"
                    border={true}
                    multiline={true}
                    id="global"
                    getContent={dataTip => dataTip}/>
                <AppHeader data-tip="test" data-for="global" clientData={this.props.clientData}/>
                <div className={"header-shadow"}/>
                <div className="app-wrapper">
                    {content}
                </div>
                <AppFooter showLegalText={appInitialized && !(this.props.isAllowedForCustomerChange && !this.props.pinCodeVerified)}/>
                {document.location.hostname === "localhost" ? null : <CookieConsent/>}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    return {
        isAllowedForCustomerChange: getCartAllowedForCustomerChange(state),
        pinCodeVerified: state.appState && state.appState.pinCodeVerified,
        appInitialized: state.appState.isInitialized,
        firstItemIdentifier: getMainArticleInCart(state),
        cartId: getCartId(state),
        clientData: state.clientDataStep && state.clientDataStep.clientData,
        selectedOutsourcingBaseArticle: getSelectedArticle(state)
    }

}

const mapDispatchToProps = (dispatch) => {

    return {}

}

export default connect(mapStateToProps, mapDispatchToProps)(AppWrapper)



/** WEBPACK FOOTER **
 ** ./src/containers/AppWrapper.js
 **/